import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { generateTextFromImage, getDataFromInvoice } from "./reducer";
import { AIInvoiceResponse, AIResponse } from "Shared/Types/ai";

interface AIState {
  loading: boolean;
  imageGenerated?: AIResponse | any;
  invoiceLoading: boolean;
  invoiceData?: AIInvoiceResponse | null;
}

const initialState: AIState = {
  loading: false,
  invoiceData: null,
  invoiceLoading: false,
};

const aiSlice = createSlice({
  name: "aiSlice",
  initialState,
  reducers: {
    clearAi(state) {
      state.loading = false;
      state.imageGenerated = undefined;
    },
    clearInvoiceDataFromAI(state) {
      state.invoiceLoading = false;
      state.invoiceData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(generateTextFromImage.fulfilled, (state, action) => {
      state.loading = false;
      state.imageGenerated = action.payload;
    });
    builder.addCase(generateTextFromImage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(generateTextFromImage.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getDataFromInvoice.fulfilled, (state, action) => {
      state.invoiceLoading = false;
      state.invoiceData = action.payload;
    });
    builder.addCase(getDataFromInvoice.pending, (state) => {
      state.invoiceLoading = true;
    });
    builder.addCase(getDataFromInvoice.rejected, (state) => {
      state.invoiceLoading = false;
    });
  },
});

export const { clearAi, clearInvoiceDataFromAI } = aiSlice.actions;

export const selectAILoading = (state: RootState) => state.ai.loading;
export const selectAIGeneratedText = (state: RootState) =>
  state.ai.imageGenerated;
export const selectInvoiceAILoading = (state: RootState) =>
  state.ai.invoiceLoading;
export const selectInvoiceAIData = (state: RootState) => state.ai.invoiceData;  

export default aiSlice;
